import { render, staticRenderFns } from "./OpfsCompatibilityDialog.vue?vue&type=template&id=f8355760"
import script from "./OpfsCompatibilityDialog.vue?vue&type=script&lang=js"
export * from "./OpfsCompatibilityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports